<template>
  <q-chip
    class="q-pl-none shadow-2"
    :style="chipStyle"
    :dense="dense"
    :class="{['bg-' + color + '-' + colorOffset]: true, 'q-pr-md': removable && !dense, 'q-pr-sm': removable && dense, 'q-pr-none': !removable}"
    :removable="removable"
    :ripple="false"
    @remove="$emit('remove')"
  >
    <div class="flex align-center overflow-hidden">
      <q-chip
        class="q-ma-none"
        :dense="dense"
        :class="{['bg-' + color + '-' + (colorOffset - 1)]: true, ['text-' + textColor]: true, 'text-caption': small}"
        :clickable="clickable"
        :title="clientName"
        @click="$emit('click')"
      >
        <q-avatar :size="dense ? '20px': '25px'">
          <profile-image
            no-animation
            :size="dense ? '20px' : '25px'"
            :initials="client.initials"
            :profile-image="client.profile_image"
          />
        </q-avatar>
        <div>
          {{ truncateString(clientName) }}
          <slot name="caption" />
        </div>
      </q-chip>
      <q-btn
        v-if="clientEmail && (!withoutBtns || (Array.isArray(withoutBtns) && !withoutBtns.includes('email')))"
        round
        dense
        icon="mdi-email"
        size="12px"
        flat
        :color="btnColor"
        @click="goToEmail(clientEmail)"
      >
        <q-tooltip>
          <span class="text-caption block">
            Email (Primary)
          </span>
          {{ clientEmail }}
        </q-tooltip>
      </q-btn>
      <q-btn
        v-if="clientPhone && (!withoutBtns || (Array.isArray(withoutBtns) && !withoutBtns.includes('phone')))"
        round
        dense
        icon="mdi-phone"
        size="12px"
        flat
        :color="btnColor"
        @click="goToPhone(clientPhone.full_phone)"
      >
        <q-tooltip>
          <span class="text-caption block">
            Phone
            <span v-if="clientPhone.type !== 'DEFAULT'">({{ clientPhone.field_name }})</span>
          </span>
          {{ clientPhone.full_phone }}
        </q-tooltip>
      </q-btn>
      <q-btn
        v-if="clientAddress && (!withoutBtns || (Array.isArray(withoutBtns) && !withoutBtns.includes('address')))"
        round
        dense
        icon="mdi-map-marker"
        size="12px"
        flat
        :color="btnColor"
        @click="goToAddress(clientAddress.full_address)"
      >
        <q-tooltip>
          <span class="text-caption block">
            Address
            <span v-if="clientAddress.type !== 'PRIMARY'">({{ clientAddress.field_name }})</span>
          </span>
          {{ clientAddress.full_address }}
        </q-tooltip>
      </q-btn>
    </div>
  </q-chip>
</template>

<script>
import clientDetails from 'components/app/clients/partials/mixins/clientDetails'

export default {
  mixins: [clientDetails],
  props: {
    client: {
      type: Object,
      required: true
    },
    clickable: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: 'grey'
    },
    textColor: {
      type: String,
      default: 'black'
    },
    btnColor: {
      type: String,
      default: 'blue-grey'
    },
    colorOffset: {
      type: Number,
      default: 2
    },
    dense: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    withoutBtns: {
      type: [Boolean, Object],
      default: false
    },
    removable: {
      type: Boolean,
      default: false
    },
    minWidth: {
      type: String,
      default: undefined
    }
  },
  emits: ['click', 'remove'],
  computed: {
    chipStyle () {
      return this.minWidth ? { 'min-width': this.minWidth } : {}
    }
  }
}
</script>
